interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message = 'Chargement…' }: LoadingScreenProps) {
  return (
    <div className="loading-screen">
      <div className="loading-spinner" />
      <p>{message}</p>
    </div>
  );
}
